
import React from 'react';
import { Utils } from '../utils';
import { NoseurGlobals } from '@rivtn/noseur';

export const useThemeMode = (): [("light" | "dark" ), React.Dispatch<React.SetStateAction<"light" | "dark">>] => {
    const [themeMode, setThemeMode] = React.useState<"light" | "dark">(Utils.getSetting("tm", "light"));

    React.useEffect(() => {
        Utils.updateSettings("tm", themeMode);
        NoseurGlobals.put(NoseurGlobals.KEYS.LAF.THEME, themeMode);
    }, [themeMode]);

    return [themeMode, setThemeMode];
};

